import { OfferLockEventProperties } from '@jusbrasil-web/shared-apollo-client/types'
import { useGTM } from '@jusbrasil-web/shared-gtm'
import { useCallback } from 'react'

import { GAGoalsFeaturesDataMapping } from '../constants'
import { GAGoalsFeaturesDataType, LockEventName } from '../types'
import { boxEventProperties } from '../utils/events'

type RegisterLockEventParams = {
  /** @default 'cta_clicked' */
  eventName?: LockEventName
  eventProperties?: OfferLockEventProperties[]
}

const isGAGoalsFeatures = (feature: string): feature is GAGoalsFeaturesDataType => {
  return Object.prototype.hasOwnProperty.call(GAGoalsFeaturesDataMapping, feature)
}

export const useRegisterLockEvent = () => {
  const gtm = useGTM()

  const registerLockEvent = useCallback(
    ({ eventName = LockEventName.CTA_CLICKED, eventProperties = [] }: RegisterLockEventParams) => {
      const defaultBoxEvent = {
        event: 'boxEvent',
        event_name: eventName,
      }
      const newEventProperties = boxEventProperties()

      eventProperties.forEach((prop) => {
        const properties = {
          ...prop,
          ...newEventProperties,
          __typename: undefined,
        }
        gtm.push({
          ...defaultBoxEvent,
          properties: JSON.stringify(properties),
        })
      })

      const eventDatas = new Set(
        eventProperties
          .map((v) => {
            if (!v.feature || !isGAGoalsFeatures(v.feature)) return

            return GAGoalsFeaturesDataMapping[v.feature]
          })
          .filter(Boolean)
      )
      eventDatas.forEach((eventData) => gtm.push({ event: 'gaEvent', ...eventData }))
    },
    [gtm]
  )

  return { registerLockEvent }
}
